export const environment = {
  production: true,
  timeout:10000,
  cacheRefreshInterval:10000000,
  API_ENDPOINT:'',
  URL_ENDPOINT:'http://localhost:5002',
  appVersion: 1,
  formsEditorClients:"Acme;Demo;Vitech"
};
